import SidebarMenu from 'react-bootstrap-sidebar-menu'
import styles from './index.module.scss'
import { RiLogoutCircleLine } from 'react-icons/ri';
import { useAuth } from '../../../../../apis/auth/AuthProvider';
import { useIntl } from 'react-intl';

const LogoutButton = () => {
    const intl = useIntl();
    const auth = useAuth();

    return (
        <div onClick={() => { auth.logOut() }}>
            <SidebarMenu.Nav.Link>
                <SidebarMenu.Nav.Icon className={styles.SidebarMenuIcon}>
                    <RiLogoutCircleLine />
                </SidebarMenu.Nav.Icon>
                <SidebarMenu.Nav.Title>{intl.messages.logout}</SidebarMenu.Nav.Title>
            </SidebarMenu.Nav.Link>
        </div>
    )
}

export default LogoutButton